import { Component, Input, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { RegistrationForm } from '../registration-form';
import { CityAndZip, Settlements } from '../../shoppingcart/contact/city-and-zip';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { ApiRequestService } from '../../shared/api-request-service';
import { RegistrationResponse } from '../registration-response';
import { DataDialog } from '../verification/dataDialog';
import { TranslationService } from '../../translation/translation.service';
import { ShoppingcartService } from '../../shoppingcart/shoppingcart.service';
import { Material } from '../../shoppingcart/material';
import { HttpHeaders } from '@angular/common/http';
import { Buffer } from 'buffer';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';

@Component({
    selector: 'lib-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})
export class SignupComponent {
    selectedAlign: 'start' | 'center' | 'end';
    getNewsOrNot = false;
    applyAszf = false;
    isAszfCheckBoxRed = false;
    errorMessage = '';
    registrationForm?: FormGroup;
    registrationFormCompany?: FormGroup;
    registrationObject?: RegistrationForm = {};
    cityAndZip?: CityAndZip = {};
    cityAndZipUrl = './assets/configurations/city-and-zip.json';
    cityAndZipPath = '';
    cityName = '';
    passwordsAreNotEqual = '';
    passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])^((?![%]).)*$/;
    @Input() admin = false;
    errorMessagee = '';
    password = 'kiscica86B';

    passwordConfirm: string | undefined = '';

    password2: string | undefined = '';

    token = '1233hjghjghjg34_.!';

    username = 'info@multiverzumkiado.hu';

    loginBaseUrl = '';

    registrationUrl = '/signup';

    @Input() hasCityAndZipUrl = true;

    isCompany = false;
    isIndividual = true;

    material: Material = {};

    hungarianPhonePrefix = '+36';

    phoneNumberPattern = '^(?:[0-9] ?){6,14}[0-9]$|^(\\+\\d{1,3}( )?)?((\\(\\d{3}\\))|\\d{3})[- .]?\\d{3}[- .]?\\d{4}$|^(\\+\\d{1,3}( )?)?(\\d{3}[ ]?){2}\\d{3}$|^(\\+\\d{1,3}( )?)?(\\d{3}[ ]?)(\\d{2}[ ]?){2}\\d{2}$';

    constructor(
        @Inject(MAT_DIALOG_DATA) public dataDialog: DataDialog,
        @Inject('AUTH_BACKEND_URL') private _loginUrl: string,
        private _apiRequestService: ApiRequestService,
        private _dialog: MatDialog,
        private _fb: FormBuilder,
        private _http: HttpClient,
        private _router: Router,
        private _loginService: LoginService,
        private _translateService: TranslationService,
        private _shoppingcartService: ShoppingcartService,
        private _toastMessageService: ToastmessageService
    ) {
        this.selectedAlign = 'end';
        this.createRegistrationForm();
        this.createRegistrationFormCompany();
        this.loginBaseUrl = _loginUrl;
    }
    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            sessionStorage.removeItem('token');
        }

        if (this.hasCityAndZipUrl) {
            this.readCityAndZipJson();
        }
    }

    closeDialog() {
        this._dialog.closeAll();

    }


    getNewsLetterOrNot() {
        this.getNewsOrNot = !this.getNewsOrNot;
    }
    applyAszfOnClick() {
        this.applyAszf = !this.applyAszf;
    }

    createRegistrationForm() {
        this.registrationForm = this._fb.group({
            password: ['', [Validators.required, Validators.pattern(this.passwordRegex)]],
            passwordConfirm: ['', [Validators.required, Validators.pattern(this.passwordRegex)]],
            firstName: ['', [Validators.required, Validators.minLength(3)]],
            lastName: ['', [Validators.required, Validators.minLength(3)]],
            email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            zipCode: ['', [Validators.required, Validators.pattern('[0-9]{4}')]],
            settlement: ['', [Validators.required, Validators.minLength(3)]],
            address: ['', Validators.required],
            phoneNumber: ['', [Validators.required,Validators.pattern(this.phoneNumberPattern)]]
        });
    }

    createRegistrationFormCompany() {
        this.registrationFormCompany = this._fb.group({
            password: ['', [Validators.required, Validators.pattern(this.passwordRegex)]],
            passwordConfirm: ['', [Validators.required, Validators.pattern(this.passwordRegex)]],
            firstName: ['', [Validators.required, Validators.minLength(3)]],
            lastName: ['', [Validators.required, Validators.minLength(3)]],
            email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            zipCode: ['', [Validators.required, Validators.pattern('[0-9]{4}')]],
            settlement: ['', [Validators.required, Validators.minLength(3)]],
            address: ['', Validators.required],
            phoneNumber: ['', Validators.required],
            companyName: ['', Validators.required],
            taxNumber: ['', Validators.required]
        });
    }


    //TODO it happens at button click
    collectRegistrationData(): boolean {
        if (this.isCompany) {
            this.registrationObject = {
                email: this.registrationFormCompany?.controls['email'].value as string | undefined,
                password: this.registrationFormCompany?.controls['password'].value as string | undefined,
                firstName: this.registrationFormCompany?.controls['firstName'].value as string | undefined,
                lastName: this.registrationFormCompany?.controls['lastName'].value as string | undefined,
                zipCode: this.registrationFormCompany?.controls['zipCode'].value as number | undefined,
                settlement: this.registrationFormCompany?.controls['settlement'].value as string | undefined,
                address: this.registrationFormCompany?.controls['address'].value as string | undefined,
                phoneNumber: this.registrationFormCompany?.controls['phoneNumber'].value as string | undefined,
                subscribedForNewsLetter: this.getNewsOrNot,
                companyName: this.registrationFormCompany?.controls['companyName'].value as string | undefined,
                taxNumber: this.registrationFormCompany?.controls['taxNumber'].value as string | undefined,
                isCompany: this.isCompany
            };
        } else if (!this.isCompany) {
            this.registrationObject = {
                email: this.registrationForm?.controls['email'].value as string | undefined,
                password: this.registrationForm?.controls['password'].value as string | undefined,
                firstName: this.registrationForm?.controls['firstName'].value as string | undefined,
                lastName: this.registrationForm?.controls['lastName'].value as string | undefined,
                zipCode: this.registrationForm?.controls['zipCode'].value as number | undefined,
                settlement: this.registrationForm?.controls['settlement'].value as string | undefined,
                address: this.registrationForm?.controls['address'].value as string | undefined,
                phoneNumber: this.registrationForm?.controls['phoneNumber'].value as string | undefined,
                subscribedForNewsLetter: this.getNewsOrNot,
                isCompany: this.isCompany
            };
        }
        this.password2 = this.registrationForm?.controls['password'].value as string | undefined;
        this.passwordConfirm = this.registrationForm?.controls['passwordConfirm'].value as string | undefined;

        if (this.password2 === this.passwordConfirm) {
            return true;
        } else {
            return false;
        }
    }


    loadCity(zip: string) {
        this.cityAndZip?.settlements?.forEach((value) => {
            if (value.zipCode === Number(zip)) {
                this.cityName = value.city as string;
            }
        });
    }

    register() {
        //TODO add companyName and taxNumber to form, isCompany boolean to radio buttons
        if (!this.applyAszf) {
            this.errorMessage = 'Kérem fogadja el az ÁSZF-et!';
            this.isAszfCheckBoxRed = true;
        } else {
            const isEqual = this.collectRegistrationData();
            //we need to put it into localStorage to auto login after registration
            const loginHeaders = new HttpHeaders()
                .set('Content-type', 'application/x-www-form-urlencoded; charset=utf-8')
                .set('Authorization', 'Basic ' + Buffer.from(this.registrationObject?.email + ':' + this.registrationObject?.password).toString('base64'));
            //TODO add loginheaders to variable to request to backend and run oauth2/token on backend side in verification usecase and put token to session

            if (isEqual) {
                if (this.isPhoneNumberValid(this.registrationObject?.phoneNumber!)) {
                    this._apiRequestService
                        .sendRequest<RegistrationForm | undefined, RegistrationResponse>(
                            this.loginBaseUrl,
                            true,
                            this.registrationObject,
                            true,
                            this.registrationUrl
                        )
                        .subscribe((answer: RegistrationResponse) => {
                            //TODO make a component to display that we sended an email with verification link and navigate there instead of navigate home
                            if (answer.message === 'Sikeres regisztráció') {
                                //this._router.navigateByUrl('/verificationmessage');
                                this._toastMessageService.displayToastMessage(TOAST_STATE.success, this._translateService.translate('login.verificationRegistration'), MAT_ICON.success);
                                this.dismissError();
                                this._dialog.closeAll();
                            } else {
                                this._dialog.closeAll();
                                alert(answer.message);
                            }
                        });
                }
            } else {
                this.passwordsAreNotEqual = 'Nem egyeznek a jelszavak!';
            }
        }
    }

    registerCompany() {
        //TODO add companyName and taxNumber to form, isCompany boolean to radio buttons
        if (!this.applyAszf) {
            this.errorMessage = 'Kérem fogadja el az ÁSZF-et!';
            this.isAszfCheckBoxRed = true;
        } else {
            this.collectRegistrationData();
            if (this.isPhoneNumberValid(this.registrationObject?.phoneNumber!)) {
                this._apiRequestService
                    .sendRequest<RegistrationForm | undefined, RegistrationResponse>(
                        this.loginBaseUrl,
                        true,
                        this.registrationObject,
                        true,
                        this.registrationUrl
                    )
                    .subscribe((answer: RegistrationResponse) => {
                        //TODO make a component to display that we sended an email with verification link and navigate there instead of navigate home
                        if (answer.message === 'Sikeres regisztráció') {
                            //this._router.navigateByUrl('/verificationmessage');
                            this._toastMessageService.displayToastMessage(TOAST_STATE.success, this._translateService.translate('login.verificationRegistration'), MAT_ICON.success);
                            this.dismissError();
                            this._dialog.closeAll();
                        } else {
                            this._dialog.closeAll();
                            alert(answer.message);
                        }
                    });
            }
        }
    }

    readCityAndZipJson() {
        this._http.get<CityAndZip[]>(this.cityAndZipUrl).subscribe((cityAndZip) => {
            this.cityAndZip = cityAndZip as CityAndZip;
            this.cityAndZip.budapestStreets?.forEach((budapest) => {
                let settlement = new Settlements();
                settlement.city = 'Budapest';
                settlement.zipCode = budapest.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
            this.cityAndZip.debrecenStreets?.forEach((debrecen) => {
                let settlement = new Settlements();
                settlement.city = 'Debrecen';
                settlement.zipCode = debrecen.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
            this.cityAndZip.gyorStreets?.forEach((gyor) => {
                let settlement = new Settlements();
                settlement.city = 'Győr';
                settlement.zipCode = gyor.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
            this.cityAndZip.miskolcStreets?.forEach((miskolc) => {
                let settlement = new Settlements();
                settlement.city = 'Miskolc';
                settlement.zipCode = miskolc.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
            this.cityAndZip.pecsStreets?.forEach((pecs) => {
                let settlement = new Settlements();
                settlement.city = 'Pécs';
                settlement.zipCode = pecs.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
            this.cityAndZip.szegedStreets?.forEach((szeged) => {
                let settlement = new Settlements();
                settlement.city = 'Szeged';
                settlement.zipCode = szeged.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
        });
    }

    companyOrNot() {
        this.isCompany = true;
        this.isIndividual = false;
    }
    individual() {
        this.isCompany = false;
        this.isIndividual = true;
    }
    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 5000);
    }

    isPhoneNumberValid(phoneNumber: string): boolean {
        if (phoneNumber.substring(0, 2) === '06' || phoneNumber.substring(0, 3) === '+36' || phoneNumber.substring(0, 4) === '0036') {
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'A telefonszám első karakterei nem tartalmazhatják a "06", "+36" és "0036" előhívószámokat!', MAT_ICON.warning);
            this.dismissError();
            return false;

        }
        return true
    }

}


